// extracted by mini-css-extract-plugin
export default {"root":"UserProfileHeader_root__pE7OJ","extraContent":"UserProfileHeader_extraContent__OSIdw"};